import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { User, Mail, Phone, Stethoscope, MapPin } from 'lucide-react';
import { useAuthStore } from '../store/auth';
const RegisterForm = () => {
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        telefone: '',
        tipo: 'paciente',
        crm: '',
        especialidade: '',
        territorio: ''
    }) ;
    const [erro, setErro] = useState('') ;
    const { registerUser, loading, user } = useAuthStore() ;
    // Pre-populate with Youware user data
    React.useEffect(() => {
        if (user) {
            setFormData(prev => ({
                ...prev,
                nome: user.display_name || user.nome || '',
                email: user.email || ''
            })) ;
        }
    }, [user]) ;
    const handleSubmit = async (e) => {
        e.preventDefault() ;
        setErro('') ;
        try {
            await registerUser(formData) ;
        }
        catch (error) {
            setErro(error.message || 'Erro ao cadastrar usuário') ;
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        })) ;
    };
    return (<div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex items-center justify-center p-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-emerald-800 mb-2">
            Bem-vindo ao GreenClub
          </h1>
          <p className="text-gray-600">Complete seu cadastro para continuar</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nome completo
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"/>
              <input type="text" name="nome" value={formData.nome} onChange={handleChange} className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500" placeholder="Seu nome completo" required/>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"/>
              <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500" placeholder="seu@email.com" required/>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Telefone
            </label>
            <div className="relative">
              <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"/>
              <input type="tel" name="telefone" value={formData.telefone} onChange={handleChange} className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500" placeholder="(11) 99999-9999" required/>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Tipo de usuário
            </label>
            <select name="tipo" value={formData.tipo} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500" required>
              <option value="paciente">Paciente</option>
              <option value="medico">Médico</option>
              <option value="representante">Representante</option>
            </select>
          </div>

          {formData.tipo === 'medico' && (<>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  CRM
                </label>
                <div className="relative">
                  <Stethoscope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"/>
                  <input type="text" name="crm" value={formData.crm} onChange={handleChange} className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500" placeholder="CRM/UF 123456" required={formData.tipo === 'medico'}/>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Especialidade
                </label>
                <input type="text" name="especialidade" value={formData.especialidade} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500" placeholder="Sua especialidade médica" required={formData.tipo === 'medico'}/>
              </div>
            </>)}

          {formData.tipo === 'representante' && (<div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Território
              </label>
              <div className="relative">
                <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"/>
                <input type="text" name="territorio" value={formData.territorio} onChange={handleChange} className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500" placeholder="Estado ou região de atuação" required={formData.tipo === 'representante'}/>
              </div>
            </div>)}

          {erro && (<motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
              {erro}
            </motion.div>)}

          <motion.button type="submit" disabled={loading} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
            {loading ? (<div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"/>) : ('Completar Cadastro')}
          </motion.button>
        </form>

        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-600 text-center">
            Ao se cadastrar, você concorda com nossos termos de uso e política de privacidade
          </p>
        </div>
      </motion.div>
    </div>) ;
};
export default RegisterForm;
